export const ZONES_SEED = []
